import React, {useContext, useEffect} from "react";
import {Col, Container, Row} from "react-bootstrap";
import PageTitle from "../../layout/PageTitle";
import PageSubTitle from "../../layout/PageSubTitle";
import {UserContext} from "../../context/UserContext";

const Settings = () => {
  // const [flash, setFlash] = useState({});
  // const [updateCall] = useMutation(updateProfileQuery)
  const { plan, planRefresh } = useContext(UserContext)

  // const onSubmit = (event) => {
  //   event.preventDefault()
  //   saveData({
  //     event: event,
  //     gqlCall: updateCall,
  //     query_key: 'updateUser',
  //     flash_callback: setFlash,
  //     success: (res) => {
  //       saveUser(res.user)
  //     }
  //   })
  // }

  useEffect(() => {
    planRefresh()
  }, []);

  // console.log(plan)
  return (
    <>
      <div className="container">
        <div className="row justify-content-md-center">
          <PageTitle title='Setari Cont' />
          <div className="page-container col">
            <Container className="bg-white rounded border shadow p-4">
              <PageSubTitle title='Plan' />
              <Row className='d-sm-flex align-items-center my-2'>
                <Col sm={12} md={4} className='align-self-start'>
                  <h4>{plan.name}</h4>
                  {/*<Link to={'#'} className='btn btn-outline-success'>Upgrade</Link>*/}
                </Col>
                <Col sm={12} md={8} className='align-self-start'>
                  <Row>
                    <Col xs={5} sm={4} md={3}>Clienti:</Col>
                    <Col>{plan.usersCount} din {plan.usersLimit}</Col>
                  </Row>
                  <Row>
                    <Col md={3} sm={4} xs={5}>Meniuri:</Col>
                    <Col>{plan.menusCount} din {plan.menusLimit}</Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <br />
              <PageSubTitle title='Notificari' />
              <Row className='d-sm-flex align-items-center my-2'>
                <Col xs={6} md={5} className='align-self-start'>In aplicatie</Col>
                <Col xs={6} md={7} className='align-self-start'>
                  <i className='bi bi-check' />
                </Col>
              </Row>

              {/*<Row className='d-sm-flex align-items-center my-2'>*/}
              {/*  <Col xs={6} md={5} className='align-self-start'>Instant pe email</Col>*/}
              {/*  <Col xs={6} md={7} className='align-self-start'>*/}
              {/*    <i className='bi bi-check' />*/}
              {/*  </Col>*/}
              {/*</Row>*/}


              {/*<Tabs>*/}
              {/*  <Tab eventKey='calendar' title='Calendar'>*/}
              {/*    <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
              {/*      <CalendarView appointments={appointments}/>*/}
              {/*    </div>*/}
              {/*  </Tab>*/}
              {/*  <Tab eventKey='appointments' title='Programari'>*/}
              {/*    <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
              {/*      <AppointmentsList appointments={appointments}/>*/}
              {/*    </div>*/}
              {/*  </Tab>*/}
              {/*  {currentUser().role == 'provider' &&*/}
              {/*    <Tab eventKey='clients' title='Clienti'>*/}
              {/*      <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
              {/*        <ClientsList clients={clients}/>*/}
              {/*      </div>*/}
              {/*    </Tab>*/}
              {/*  }*/}
              {/*  {currentUser().role == 'client' &&*/}
              {/*    <Tab eventKey='users' title='Angajati'>*/}
              {/*      <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
              {/*        <ClientsList users={users}/>*/}
              {/*      </div>*/}
              {/*    </Tab>*/}
              {/*  }*/}
              {/*  <Tab eventKey='orgs' title='Organizatii'>*/}
              {/*    <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
              {/*      <OrganizationsList orgs={user.organizations}/>*/}
              {/*    </div>*/}
              {/*  </Tab>*/}
              {/*</Tabs>*/}
            </Container>
          </div>
        </div>
      </div>

    </>
  );
}

export default Settings
